import { Component } from "react";
import { withRouter } from "react-router-dom";
import requireAuth from "components/hoc/requireAuth";

class CalendarHome extends Component {
  componentDidMount() {
    // window.location.href = "/bakim.html";
    const roles = localStorage.getItem("roles");

    if (roles.includes("Manager")) {
      this.props.history.push("/calendar/manager");
    } else {
      this.props.history.push("/calendar/personnel");
    }
  }

  render() {
    return null;
  }
}

export default withRouter(requireAuth(CalendarHome));
